import logo from './logo.svg';
import './App.css';
import CountDownTimer from './CountDownTimer';
import ScoreBoard from './Scoreboard';
import ResetButtonImage from './images/reset-button-white.svg'
import { useState } from 'react';

function App() {
  const [timerKey, setTimerKey] = useState(0);
  const [scoreKey, setScoreKey] = useState(1);
  const [matchLength, setMatchLength] = useState(300);

  let mapping = {
    0: 180, 1: 240, 2: 300, 3: 300,
    4: 360, 5: 420, 6: 480, 7: 300
  }

  const resetKeys = () => {
    const rand1 = Math.floor(Math.random() * 20000);
    const rand2 = Math.floor(20000 + Math.random() * 20000);
    setTimerKey(rand1);
    setScoreKey(rand2);
  };

  const updateMatchDuration = (e) => {
    console.log("Selected value:" + e.target.value, mapping[e.target.value]);
    setMatchLength(mapping[e.target.value]);
    resetKeys();
  };

  const confirmReset = (e) => {
    e.preventDefault();
    if (window.confirm("Are you sure?") === true) {
      resetKeys();
    }
  };

  const ResetButton = () => {
    return (
      <div>
        <div className='reset-button' onClick={(e) => confirmReset(e) }>
          <div className='button-container'>
            <img alt="reset button" src={`${ResetButtonImage}`}></img>
            <b>Reset</b>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="category-select">
          <span>Sarja:</span>
          <select defaultValue={3} onChange={updateMatchDuration}>
            <option value="0">Junnut -11v</option>
            <option value="1">Junnut 12v-13v</option>
            <option value="2">Junnut +14v</option>
            <option value="3">Aikuiset valkovyöt</option>
            <option value="4">Aikuiset sinivyöt</option>
            <option value="5">Aikuiset purppuravyöt</option>
            <option value="6">Aikuiset ruskea- ja mustavyöt</option>
            <option value="7">Seniorit</option>
          </select>
        </div>
      </header>
      <CountDownTimer key={timerKey} startValue={matchLength} />
      <ScoreBoard key={scoreKey}/>
      <ResetButton />
    </div>
  );
}

export default App;
